import { LoaderFunctionArgs, redirect, RouteObject } from 'react-router-dom'
import { BACKOFFICE_ROUTES, COMPANY_MANAGER_LEGACY_KEYS } from './paths'

// ============================================
// REDIRECTS LEGADOS DO BACKOFFICE
// As rotas de companyManager foram migradas de /admin/* para /backoffice/*.
// Estas rotas mantêm os links antigos (bookmarks, links do monólito, e-mails)
// funcionando, redirecionando 1:1 para o novo path e preservando params
// dinâmicos e querystring.
//
// A V2 removerá esses redirects (migração definitiva, sem compatibilidade).
// ============================================

/**
 * Monta um loader que redireciona um path legado `/admin/*` para o novo
 * equivalente `/backoffice/*`, substituindo os params dinâmicos e preservando
 * a querystring original.
 */
const makeRedirectLoader =
  (toPattern: string) =>
  ({ params, request }: LoaderFunctionArgs) => {
    let target = toPattern
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        target = target.replace(`:${key}`, value)
      }
    }
    const { search } = new URL(request.url)
    return redirect(`${target}${search}`)
  }

export const BackofficeCompatRedirects = (): RouteObject[] => {
  return COMPANY_MANAGER_LEGACY_KEYS.map(key => {
    const newPath = BACKOFFICE_ROUTES[key].value
    const legacyPath = newPath.replace('/backoffice', '/admin')

    return {
      path: legacyPath,
      loader: makeRedirectLoader(newPath)
    }
  })
}
